var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDotsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 8,
    viewBox: "0 0 32 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.99417 0C5.05349 0 6.06942 0.421427 6.81847 1.17157C7.56752 1.92172 7.98834 2.93913 7.98834 4C7.98834 5.06087 7.56752 6.07828 6.81847 6.82843C6.06942 7.57857 5.05349 8 3.99417 8C2.93485 8 1.91892 7.57857 1.16986 6.82843C0.420813 6.07828 0 5.06087 0 4C0 2.93913 0.420813 1.92172 1.16986 1.17157C1.91892 0.421427 2.93485 0 3.99417 0ZM27.9592 0C29.0185 0 30.0344 0.421427 30.7835 1.17157C31.5325 1.92172 31.9534 2.93913 31.9534 4C31.9534 5.06087 31.5325 6.07828 30.7835 6.82843C30.0344 7.57857 29.0185 8 27.9592 8C26.8999 8 25.8839 7.57857 25.1349 6.82843C24.3858 6.07828 23.965 5.06087 23.965 4C23.965 2.93913 24.3858 1.92172 25.1349 1.17157C25.8839 0.421427 26.8999 0 27.9592 0ZM16.3377 0C17.3971 0 18.413 0.421427 19.1621 1.17157C19.9111 1.92172 20.3319 2.93913 20.3319 4C20.3319 5.06087 19.9111 6.07828 19.1621 6.82843C18.413 7.57857 17.3971 8 16.3377 8C15.2784 8 14.2625 7.57857 13.5134 6.82843C12.7644 6.07828 12.3436 5.06087 12.3436 4C12.3436 2.93913 12.7644 1.92172 13.5134 1.17157C14.2625 0.421427 15.2784 0 16.3377 0Z",
    fill: "#3C3C3C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotsIcon);
export default __webpack_public_path__ + "static/media/dots-icon.b66269261969f88bc5c3c865cbafd9bc.svg";
export { ForwardRef as ReactComponent };